import { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-6 right-6 z-50
        bg-gradient-to-r from-[#0070d2] to-[#00a8f3]
        text-white p-4 rounded-full shadow-xl
        transition-all duration-300 ease-in-out
        hover:scale-110 hover:shadow-2xl
        ${isVisible ? 'opacity-100 scale-100 animate-bounce-slow' : 'opacity-0 scale-75 pointer-events-none'}
      `}
      aria-label="Подняться наверх"
    >
      <FaArrowUp className="text-xl" />
    </button>
  );
}
